import styled from "styled-components";
export const Styles = styled.div`
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .img-container {
    width: 200px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .img-container img {
    max-width: 100%;
    max-height: 85%;
    object-fit: contain;
  }
  .swiper-button-lock {
    display: none;
  }
  .name {
    position: relative;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 5px;
    font-size: 1.1rem;
    margin-top: 0.5rem;
  }
  .name::before {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--light-purple);
    transform: scaleX(0);
    transition: transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
  .img-container:hover .name::before {
    transform: scaleX(1);
    background-color: var(--dark-purple);
  }
`;
